export default __webpack_public_path__ + "static/media/Chapters.04689be9.png";